import { __module as o } from "../../../_virtual/normalizeEmail.js";
import { m as l } from "./util/merge.js";
!function (o, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (o, l) {
    l = (0, a.default)(l, t);
    var e = o.split("@"),
      u = e.pop(),
      d = [e.join("@"), u];
    if (d[1] = d[1].toLowerCase(), "gmail.com" === d[1] || "googlemail.com" === d[1]) {
      if (l.gmail_remove_subaddress && (d[0] = d[0].split("+")[0]), l.gmail_remove_dots && (d[0] = d[0].replace(/\.+/g, c)), !d[0].length) return !1;
      (l.all_lowercase || l.gmail_lowercase) && (d[0] = d[0].toLowerCase()), d[1] = l.gmail_convert_googlemaildotcom ? "gmail.com" : d[1];
    } else if (m.indexOf(d[1]) >= 0) {
      if (l.icloud_remove_subaddress && (d[0] = d[0].split("+")[0]), !d[0].length) return !1;
      (l.all_lowercase || l.icloud_lowercase) && (d[0] = d[0].toLowerCase());
    } else if (i.indexOf(d[1]) >= 0) {
      if (l.outlookdotcom_remove_subaddress && (d[0] = d[0].split("+")[0]), !d[0].length) return !1;
      (l.all_lowercase || l.outlookdotcom_lowercase) && (d[0] = d[0].toLowerCase());
    } else if (r.indexOf(d[1]) >= 0) {
      if (l.yahoo_remove_subaddress) {
        var h = d[0].split("-");
        d[0] = h.length > 1 ? h.slice(0, -1).join("-") : h[0];
      }
      if (!d[0].length) return !1;
      (l.all_lowercase || l.yahoo_lowercase) && (d[0] = d[0].toLowerCase());
    } else s.indexOf(d[1]) >= 0 ? ((l.all_lowercase || l.yandex_lowercase) && (d[0] = d[0].toLowerCase()), d[1] = "yandex.ru") : l.all_lowercase && (d[0] = d[0].toLowerCase());
    return d.join("@");
  };
  var a = l && l.__esModule ? l : {
      default: l
    },
    t = {
      all_lowercase: !0,
      gmail_lowercase: !0,
      gmail_remove_dots: !0,
      gmail_remove_subaddress: !0,
      gmail_convert_googlemaildotcom: !0,
      outlookdotcom_lowercase: !0,
      outlookdotcom_remove_subaddress: !0,
      yahoo_lowercase: !0,
      yahoo_remove_subaddress: !0,
      yandex_lowercase: !0,
      icloud_lowercase: !0,
      icloud_remove_subaddress: !0
    },
    m = ["icloud.com", "me.com"],
    i = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"],
    r = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"],
    s = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
  function c(o) {
    return o.length > 1 ? o : "";
  }
  o.exports = e.default, o.exports.default = e.default;
}(o, o.exports);
var e = o.exports;
export { e as n };